/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import { routerShape, locationShape } from 'react-router';
import LazyHydrate from 'react-lazy-hydration';
import preload from 'preload';
import PropTypes from 'prop-types';
// import each from 'lodash/each';
import map from 'lodash/map';
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import isArray from 'lodash/isArray';
import get from 'lodash/get';
import indexOf from 'lodash/indexOf';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import { emit } from 'helpers/global-events';
import { reportError } from 'api/api-errors';
import DataProvider from 'api/data-provider';
import apiDecorator from 'api/api-decorator';
import seoPreload, { seoDecorator } from 'api/seo';
import { authConnect, UserProp } from 'auth';
import Subscribe from 'subsys/notifications/subscribe';
import { FavoritesButton, FavoriteWrapper } from 'subsys/favorites';
import contentBlock, { blockPreloader } from 'containers/content-block';
import sensor from 'components/sensor';
import AdSense from 'components/adsense';
// import DropDown from 'components/drop-down';
import Button from 'components/button';
import Row, { Col } from 'components/row';
// import { iconTypes } from 'components/icon';
// import Block, { BlockHeader, BlockContent } from 'components/block';
// import { BannersRight } from 'components/banners';
// import SubscribeModal from 'components/subscribe-modal';
// import { AccordionBlock } from 'components/accordion';
import Breadcrumbs from 'components/breadcrumbs';
import { SearchInput } from 'components/header';
import Notification from 'components/notification';
import { OpenGraphImage } from 'components/image';
import Paginator, { Control, Container, Pages } from 'components/paginator';

import config from 'src-sites/forum/const-config';
import linksForum from 'src-sites/forum/links';

import BlockLC from './block-lc';
import BlockDev from './block-dev';
import ForumListMain, { checkTitle, checkButton } from './main-forum-list';
import AsideBlockList from './aside-block-list';
// import MainTopicList from './main-topic-list';
import AdminPanel from '../common/admin/panel';
import ForumTopicAdd from '../common/forum-topic-add';
import TopicList from '../common/topic-list';
// import StatisticsBlock from '../common/statistics';
import BannerForumsList from '../common/banner-forums-list';

import blocksConfig from '../blocks/config';
import BlockWrapper from '../blocks/block-wrapper';

import translates from '../forum-i18n';

import 'styles/forum/common/admin/panel/_admin-panel-forum.scss';
// import 'styles/forum/section-forum/_aside-list.scss';
import 'styles/forum/section-forum/_page-forum.scss';

const bemClasses = new Bem('forum');
const bemClassesAsideList = new Bem('asideList');
// const bemClassesBlockForumDescription = new Bem('forumDescription');

const { limitCountForumTopics } = config;

// Show topics for forum.
@preload((routeProps) => {
  const { params } = routeProps;
  const { landing } = params;
  return {
    /**
     * TODO
     * Пока что выпилил все непонятное. Грузятся только базовые данные для форума
     * Надо продумать, какие данные нем нужны, и прелоадить их. Что-то сделать управляемыми
     * блоками может быть, что-то для ускорения процесса захардкодить.
     * То, как оно работало - это в принципе недопустимо. По сотне запросов на страницу и адские тормоза
     */
    // Forum data
    forum: [DataProvider.preload, {
      url: 'forum/forum',
      query: {
        'forum-id': landing.entity_id
      }
    }],
    // Forum subforums
    /**
     * TODO было сделано так, что выдавалось всё дерево детей этого форума. Надо продумать как делаем
     * либо выводим только непосредственных детей форума, либо выводим всё дерево под-под-под и т.д. форумоа
     */
    forumSubforums: [DataProvider.preload, {
      url: 'forum/forum',
      query: {
        parentId: landing.entity_id,
        'order-by': 'forum_title'
      }
    }],
    // Forum topics
    forumTopics: [DataProvider.preload, {
      url: 'forum/topic-list',
      query: {
        'forum-id': landing.entity_id,
        'order-by-desc': 'topic_last_post_time',
        'show-unread-status': 1,
        count: true,
        limit: limitCountForumTopics,
        offset: landing.offset
      }
    }],

    // TODO разработать логику и оптимизировать. Это вроде как выводит список форумов
    // Данные рут форума
    rootForums: [DataProvider.preload, {//TODO Это прелоадер категорий он есть везде в правой колонке
      url: 'forum/forum',
      query: {
        'root-forums': 1,
        'order-by': 'weight'
      }
    }],
    preloadedLc: {
      $wait: ['forum'],
      $callback: (data) => {
        const cfg = {};
        const lc_id = get(data, 'forum.data[0].lc_id');
        if (lc_id) {
          cfg.lc = [DataProvider.preload, {
            url: 'domik/location/newbuild',
            query: { id: lc_id},
            cache: 60
          }];
        }
        return cfg;
      }
    },
    landingLc: {
      $wait: ['forum'],
      $callback: (data) => {
        const cfg = {};
        const domik_land_tree = get(data, 'forum.data[0].domik_land_tree');
        if (domik_land_tree) {
          cfg.landingLc = [DataProvider.preload, {
            url: 'bild/complex-child-landings',
            query: {
              branch: domik_land_tree,
              entityNot: 'object'
            },
            cache: 60,
            requestClientCache: 1,
          }];
        }
        return cfg;
      }
    },
    preloadedDeveloper: {
      $wait: ['forum'],
      $callback: (data) => {
        const cfg = {};
        const developer_id = get(data, 'forum.data[0].developer_id');
        if (developer_id) {
          cfg.developer = [DataProvider.preload, {
            url: 'domik/users/developer',
            query: { id: developer_id },
            cache: 60
          }];
        }
        return cfg;
      }
    },
    landing: [() => Promise.resolve({
      ...landing,
      topicsCount: limitCountForumTopics,
      query: landing.params,
      breadcrumbsPath: landing.breadcrumbs_path,
    }), {}],
    ...blockPreloader({
      project: 'forum',
      entity: 'forumPage'
    }, blocksConfig, ['forum']),
    ...seoPreload({ entity: 'forumPage' }, ['landing', 'forum', 'preloadedDeveloper']),
    //
    //
    // Данные правил
    // preloadedRulesList: {
    //   $wait: ['forum'],
    //   $callback: (data) => {
    //     const cfg = {};
    //     each(data.forum.data, val => (
    //       cfg.rulesList = [DataProvider.preload, {
    //         url: 'forum/forum',
    //         query: {
    //           'tree-parent': val.tree
    //         }
    //       }]
    //     ));
    //     return cfg;
    //   }
    // },
    /* TODO разобраться нахуя это надо
    preloadedLastTopicList: {
      $wait: ['forum'],
      $callback: (data) => {
        const cfg = {};
        const forum_id = get(data, 'forum.data[0].id');
        const forum_type = get(data, 'forum.data[0].forum_type');
        const query = {
          'order-by-desc': 'topic_last_post_time',
          count: true,
          limit: 20
        }
        if (forum_type === "category") {
          query.tree = forum_id;
        } else {
          query.forumId = forum_id;
        }
        if (!forum_id) return cfg;
        cfg[forum_id] = [DataProvider.preload, {
          url: 'forum/topic-list',
          query,
          cache: 5
        }];
        return cfg;
      }
    },
    preloadedOtherTopicList: {
      $wait: ['rootForums'],
      $callback: (data) => {
        const cfg = {};
        const rootForums = get(data, 'rootForums.data', []);
        if (!rootForums.length) return cfg;

        each(rootForums, (val, key) => {
          if (!val.id) return null;
          cfg[key] = [DataProvider.preload, {
            url: 'forum/topic-list',
            query: {
              'tree': val.id,
              'order-by-desc': 'topic_last_post_time',
              count: true,
              limit: 10
            },
            cache: 5
          }]
        });
        return cfg;
      }
    }
    */
  }
})
@seoDecorator({
  defaultTitle: 'Forum.domik.ua',
  advancedVars: {}
})
@I18nHoc(translates())
export default class PageForum extends Component {
  static propTypes = {
    router: routerShape,
    location: locationShape,
    params: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string
    }),

    // Preloaded data
    forum: PropTypes.shape({}),
    forumTopics: PropTypes.shape({}),
    forumSubforums: PropTypes.shape({}),

    rootForums: PropTypes.shape({}),
    preloadedRulesList: PropTypes.shape({}),
    preloadedLastTopicList: PropTypes.shape({}),
    preloadedOtherTopicList: PropTypes.shape({}),
    preloadedLc: PropTypes.shape({}),
    preloadedDeveloper: PropTypes.shape({})
  };

  renderSearchContentBlock =(name)=> {
    return contentBlock(blocksConfig, name, this.props, { classNameWrapper: name, location: get(this, 'props.location') });
  }

  render() {
    const { i18n } = this;
    const {
      router, location, params, forum, rootForums, seoData,
      forumTopics, forumSubforums = {}, preloadedRulesList = {},
      preloadedLastTopicList, preloadedOtherTopicList, preloadedDeveloper, preloadedLc, landingLc = {}
    } = this.props;
    // const rootForumData = get(rootForums, 'data');
    // const topic = i18n('h1Main');
    // const header = get(seoData, 'header') ? seoData.header : topic;
    const forum_title = get(forum, 'data[0].forum_title');
    const forumId = +get(forum, 'data[0].id');
    const currentTopicList = get(preloadedLastTopicList, `[${forumId}].data`);
    if (!this.randRootIds) this.randRootIds = getRandRootIds.call(this, preloadedOtherTopicList);
    const parent_forum_title = get(forum, 'data[0].parent_forum_title');
    const parentForumUrl = get(forum, 'data[0].parentForumUrl');
    const forumParent = +get(forum, 'data[0].parent');
    const dataBreadcrumbs = [
      {
        name: i18n('breadcrumbsMain'),
        builder: linksForum.sectionForum,
        builderProps: { title: i18n('breadcrumbsMain') }
      }
    ];
    if (parentForumUrl && parent_forum_title && forumParent) {
      dataBreadcrumbs.push({
        name: parent_forum_title,
        builder: linksForum.sectionForums,
        builderProps: {
          id: forumParent,
          forum_title: parent_forum_title,
          forumUrl: parentForumUrl
        }
      });
    }
    dataBreadcrumbs.push({
      name: forum_title,
      builder: linksForum.sectionForums,
      builderProps: get(forum, 'data[0]')
    });

    return (
      <>
        <Breadcrumbs {...bemClasses('breadcrumbs', 'top')} data={dataBreadcrumbs} noJson />
        <Row mtColumn mpColumn>
          <Col mdAdjust={330} allPr={0}>
            <DataProvider
              url="forum/forum"
              updateEvent="updateForumThemes"
              query={{ 'forum-id': get(params, 'landing.id') }}
              preloaded={forum}
            >
              <ForumNow
                router={router}
                path={location.pathname}
                params={params}
                preloadedForumList={forumSubforums}
                preloadedRulesList={preloadedRulesList.rulesList}
                preloadedTopicList={forumTopics}
                preloadedLc={preloadedLc.lc}
                landingLc={landingLc}
                preloadedDeveloper={preloadedDeveloper.developer}
                renderSearchContentBlock={this.renderSearchContentBlock}
              />
            </DataProvider>
            <AdSense />
          </Col>
          <Col {...bemClasses('col', 'aside')} mdCw={330} mdPl={30} mtOrder={1} mpOrder={1} allPr={0}>
            {/*!!rootForumData && !!rootForumData.length &&
              <RootTopic
                router={router}
                data={rootForumData}
                forum_title={forum_title}
                forumId={forumId}
                forumParent={forumParent}
                searchPlaceholder={i18n('searchOnForumDomikUA')}
              />
            */}
            <LazyHydrate whenVisible>
              {contentBlock(blocksConfig, 'rightColumn1', this.props, { wrapper: BlockWrapper, withContainer: false })}
              {contentBlock(blocksConfig, 'rightColumn2', this.props, { wrapper: BlockWrapper, withContainer: false })}
              {contentBlock(blocksConfig, 'rightColumn3', this.props, { wrapper: BlockWrapper, withContainer: false })}
              {contentBlock(blocksConfig, 'rightColumn4', this.props, { wrapper: BlockWrapper, withContainer: false })}
              {contentBlock(blocksConfig, 'rightColumn5', this.props, { wrapper: BlockWrapper, withContainer: false })}
              {contentBlock(blocksConfig, 'rightColumn6', this.props, { wrapper: BlockWrapper, withContainer: false })}
              {contentBlock(blocksConfig, 'rightColumn7', this.props, { wrapper: BlockWrapper, withContainer: false })}
              {contentBlock(blocksConfig, 'rightColumn8', this.props, { wrapper: BlockWrapper, withContainer: false })}
              {contentBlock(blocksConfig, 'rightColumn9', this.props, { wrapper: BlockWrapper, withContainer: false })}
              {contentBlock(blocksConfig, 'rightColumn10', this.props, { wrapper: BlockWrapper, withContainer: false })}
            </LazyHydrate>
            <AsideBlockList
              router={router}
              topic={i18n('nowDiscussing')}
              topicList={currentTopicList}
              quantity={20}
              view="gray"
            />
            {/*!!this.randRootIds && !!this.randRootIds.length &&
            map(this.randRootIds, (it, key) => {
              const tree = get(it, 'data[0].tree', '');
              const treeArr = tree.split('.');
              const root = get(treeArr , '[0]');
              const rootIndex = findIndex(rootForumData, it => it.id === +root);

              return (
                <AsideBlockList
                  router={router}
                  key={key}
                  topic={get(rootForumData, `[${rootIndex}].forum_title`) || i18n('nowDiscussing')}
                  topicList={get(it, 'data')}
                  quantity={10}
                  view="gray"
                />
              );
            })*/}
          </Col>
        </Row>
        <Breadcrumbs {...bemClasses('breadcrumbs')} data={dataBreadcrumbs} />
      </>
    );
  }
}

// Show information about current forum.
@authConnect()
@apiDecorator
@I18nHoc(translates())
class ForumNow extends Component {
  static propTypes = {
    className: PropTypes.string,
    // eslint-disable-next-line
    id: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    params: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      landing: PropTypes.shape({ }),
    }),
    auth: UserProp,
    actionDoLogin: PropTypes.func,
    router: routerShape,

    // Preloaded data
    preloadedForumList: PropTypes.shape({}),
    preloadedRulesList: PropTypes.shape({}),
    preloadedTopicList: PropTypes.shape({}),
    preloadedLc: PropTypes.shape({}),
    landingLc: PropTypes.shape({}),
    preloadedDeveloper: PropTypes.shape({}),
    renderSearchContentBlock: PropTypes.func
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.onHandleSelect = this.onHandleSelect.bind(this);
    this.onHandleDeleteTheme = this.onHandleDeleteTheme.bind(this);
    this.renderFavoriteButton = this.renderFavoriteButton.bind(this);

    this.state = {
      selectedThemes: null,
      search: null,
      readAllTopicsAfterLogin: false
    };
  }

  onSearchChange = (search) => {
    this.setState({ search })
  }

  componentDidUpdate(prevProps) {
    const { auth = {} } = this.props;
    const { readAllTopicsAfterLogin } = this.state;
    if (auth.authenticated !== get(prevProps, 'auth.authenticated', false)) {
      if (this.state.selectedThemes) this.setState({ selectedThemes: null });
      emit('updateForumThemes');
      emit('updateClubTopics');
    }
    if (auth.authenticated && readAllTopicsAfterLogin) {
      this.readAllTopics();
    }
  }

  onHandleDeleteTheme() {
    console.log('theme deleted'); // eslint-disable-line
  }

  /**
   * Add/remove selected themes in state. Admin logic only.
   *
   * @param checked
   * @param data {object}
   */
  onHandleSelect(checked, data = {}) {
    let selectedThemes = this.state.selectedThemes ? [...this.state.selectedThemes] : [];

    if (!isArray(data)) {
      const index = findIndex(selectedThemes, it => it.id === data.id);

      if (checked) selectedThemes.push(data);
      if (!checked && index >= 0) selectedThemes.splice(index, 1);
      if (!selectedThemes.length) selectedThemes = null;

      return this.setState({ selectedThemes });
    }

    selectedThemes = filter(selectedThemes, post => !includes(data, post));
    this.setState({ selectedThemes });
  }

  renderFavoriteButton({ data }) {
    const entity_id = +get(this, `props.data[0].id`);

    if (!entity_id) return null;

    const index = findIndex(data, { entity_id });

    return (
      <FavoritesButton
        {...bemClasses('favorites')}
        project="forum"
        entity="publication"
        entityId={entity_id}
        subgroup="forum_forum"
        inFavorites={index > -1}
      />
    );
  }

  readAllTopics = () => {
    const { i18n } = this;
    const { auth = {}, actionDoLogin } = this.props;

    const forumId = get(this, 'props.data[0].id');
    if (!forumId) return null;

    if (!auth.authenticated && actionDoLogin ) {
      this.setState({ readAllTopicsAfterLogin : true });
      return actionDoLogin();
    }

    this.api.post('action/forum/actions-read-topics/read-forum-topics', {
      postData: {
        forumId
      }
    })
      .then((data) => {
        emit('updateClubTopics')
        Notification.success(i18n('readAllTopicsDone'));
      }).catch(error => reportError(error));

    this.setState({ readAllTopicsAfterLogin : false });
  }

  afterItemsContent =()=> {
    const { renderSearchContentBlock } = this.props;

    if (!renderSearchContentBlock) return null;

    return [
      renderSearchContentBlock('blockFAdvert4'),
      renderSearchContentBlock('blockFAdvert15')
    ];
  };

  render() {
    const { i18n } = this;
    const {
      data = [], params = {}, auth = {}, actionDoLogin, checkPermission, router,
      preloadedTopicList, preloadedForumList, preloadedDeveloper, preloadedLc, landingLc
    } = this.props;
    const dataObj = data[0];
    let opgImageId = null;
    if (dataObj.lc_id && get(preloadedLc, 'data[0].product.addition_fields.topic_lc')) {
      opgImageId = get(preloadedLc, 'data[0].images.others[0].id');
    }
    if (dataObj.developer_id) {
      opgImageId = get(dataObj, 'dev_image');
    }

    const opgProps = {};
    if (opgImageId) opgProps.imageId = opgImageId;
    const { selectedThemes } = this.state;
    const { landing = {} } = params;
    const { offset } = landing;
    const page = (offset/limitCountForumTopics)+1;

    const elementsRight = (
      <Row {...bemClasses('row', 'pagesAside')}>
        <Col {...bemClasses('col', 'themesQuantity')} allPr={0}>
          <span {...bemClasses('text')}>Тем: {preloadedTopicList.count || 0}</span>
        </Col>
        <Col {...bemClasses('col', 'search')} allAuto allPr={0}>
          <SearchInput
            {...bemClasses('search', 'paginator')}
            params={params}
            router={router}
            linkBuilder={linksForum.sectionSearch}
            queryParams={{ tree: dataObj.tree }}
            queryParamName="search"
            placeholder={i18n('searchInSection')}
            search={this.state.search}
            onSearchChange={this.onSearchChange}
          />
        </Col>
        <Col {...bemClasses('col', 'btn')} allAuto allPr={0}>
          <ForumTopicAdd
            forum_id={dataObj.id}
            router={this.props.router}
            modalBtnProps={{
              ...bemClasses('btn', 'topicNew'),
              title: i18n('topicNew'),
              label: i18n('topicNew')
            }}
            modalSize="content"
            modalHeaderTitle={i18n('addTopic')}
            auth={auth}
            actionDoLogin={actionDoLogin}
            checkPermission={checkPermission}
            hideModalBtn
          />
        </Col>
      </Row>
    );

    return (
      <>
        <LazyHydrate ssrOnly>
          <OpenGraphImage
            {...opgProps}
          />
        </LazyHydrate>
        {dataObj.forum_title &&
          <h1
            {...bemClasses('text', 'h1')}
            children={dataObj.forum_title}
          />
        }
        <BannerForumsList forumId={dataObj.id} />
        {dataObj.lc_id && preloadedLc &&
          <DataProvider
            url="domik/location/newbuild"
            updateEvent="updateForumThemes"
            preloaded={preloadedLc}
            preloadedStatic
            injectPropName='data'
          >
            <BlockLC
              landingLc={landingLc}
            />
          </DataProvider>
        }
        {dataObj.developer_id && preloadedDeveloper &&
          <DataProvider
            url="domik/users/developer"
            updateEvent="updateForumThemes"
            preloaded={preloadedDeveloper}
            preloadedStatic
            injectPropName='data'
          >
            <BlockDev
              devImage={get(dataObj, 'dev_image')}
            />
          </DataProvider>
        }
        <DataProvider
          url="forum/forum"
          query={{
            parentId: dataObj.id,
            'order-by': 'forum_title'
          }}
          preloaded={preloadedForumList}
        >
          <ForumListMain
            entity='page-forum'
            forumType={dataObj.forum_type}
          />
        </DataProvider>
        <div {...bemClasses('paginatorWrapper', 'before')}>
          <Subscribe
            {...bemClasses('subscribe')}
            mode="active"
            labelSubscribe={i18n('subscribeForum')}
            labelUnsubscribe={i18n('unsubscribeForum')}
            type="forumReply"
            entity="forum"
            entity_id={parseInt(dataObj.id)}
          />
          <FavoriteWrapper
            project="forum"
            entity="publication"
          >
            {favData => this.renderFavoriteButton(favData)}
          </FavoriteWrapper>
        </div>
        {/*
        <AccordionBlock
          {...bemClasses('accordion')}
          panelTopic={dataObj.forum_title}
          dataView="viewBlockForum"
          trackAs={dataObj.id}
          children={
            <>
              <BannerForumsList forumId={params.id} />
              <DataProvider
                url="forum/forum"
                query={{
                  parent: dataObj.tree,
                  'order-by': 'forum_title'
                }}
                preloaded={preloadedForumList}
              >
                <ForumListMain showTitle={false} forumType={dataObj.forum_type}/>
              </DataProvider>
            </>
          }
        />
        */}
        {dataObj.forum_type !== 'category' &&
          <Paginator
            url="forum/topic-list"
            updateEvent="updateClubTopics"
            query={{
              'forum-id': dataObj.id,
              'order-by-desc': 'topic_last_post_time',
              'show-unread-status': 1,
              'forum-type-forum': 1
            }}
            queryJson
            limit={limitCountForumTopics}
            changeUrl
            page={page}
            preloaded={preloadedTopicList}
            withTopPages
            noData={
              <div {...bemClasses('pages')}>
                {elementsRight}
                <div children={i18n('noDataText')} />
              </div>
            }
          >
            <Control />
            <Container
              {...bemClasses('list')}
              injectPropName="data"
              afterItemsContent={this.afterItemsContent}
            >
              <TopicList
                router={router}
                auth={auth}
                selectedThemes={selectedThemes}
                onHandleSelectTheme={this.onHandleSelect}
              />
            </Container>
            <Pages
              {...bemClasses('pages')}
              linkBuilder={linksForum.sectionForumTopics}
              linkBuilderProps={{
                paramsTitle: params.title,
                forumUrl: dataObj.forumUrl,
                id: params.id
              }}
              router={router}
              pagesRow
              // withPageChange
              // otherPropsBtnChangePage={{
              //   label: '№'
              // }}
              elementsRight={elementsRight}
            />
          </Paginator>
        }
        <Button
          {...bemClasses('btn', 'readAll')}
          onClick={this.readAllTopics}
          label={i18n('readAllTopics')}
          title={i18n('readAllTopics')}
        />
        {dataObj.allRules &&
          <AdminPanel
            selectedItems={selectedThemes}
            onHandleDelete={this.onHandleDeleteTheme}
            onResetSelection={this.onHandleSelect}
            entity="themes"
          />
        }
        {/*
        <StatisticsBlock forumId={params.id} />
        */}
      </>
    );
  }
}

@sensor
export class RootTopic extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    forum_title: PropTypes.string,
    topicTree: PropTypes.string,
    forumId: PropTypes.number,
    forumParent: PropTypes.number,
  };

  static getDerivedStateFromProps(props, state) {
    if(props.forum_title !== state.prevPropsTitle){
      return {
        sublistParent: null,
        prevPropsTitle: props.forum_title
      }
    }
    return null
  }

  constructor(props, ctx) {
    super(props, ctx);

    this.onResizeHandle = this.onResizeHandle.bind(this);
    this.onResize = this.onResizeHandle.bind(this);
    this.sublistDelay = null;

    this.state = {
      device: 'desktop'
    };
  }

  componentDidMount() {
    this.onResizeHandle(this.sensor.getRuntime());
  }

  componentDidUpdate(prevProps) {
    if(this.props.forum_title !== prevProps.forum_title && this.ddRef) {
      this.ddRef.getInstance().close();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.autoCloseMapLegendDelay);
    clearTimeout(this.sublistDelay);
  }

  onResizeHandle({ media: { desktop, tablet, phone } = {} }) {
    let device;
    if (desktop) {
      device = 'desktop';
    } else if (tablet) {
      device = 'tablet';
    } else if (phone) {
      device = 'phone';
    }

    if (device !== this.state.device) {
      this.setState({ device });
    }
  }

  showSublist =(it)=> {
    const sublistParent = +get(it, 'id') || +get(it.currentTarget, 'id');
    this.setState({sublistParent})
  };

  hideSublist =()=> {
    this.sublistDelay = setTimeout(() => this.setState({sublistParent: null}), 1500);
  };

  renderSublist =()=> {
    const { data } = this.props;
    const { sublistParent } = this.state;
    const index = findIndex(data, it => it.id === sublistParent);
    const currentForum = get(data, `[${index}]`);
    let sublist = [];

    if (sublistParent) {
      map(data, (listItem) => {
        map(listItem, (sublistItem, key) => {
          if (key === 'children') return sublist = [...sublist, ...sublistItem];
        })
      });
      sublist = filter(sublist, it => it.parent === sublistParent);
    }

    if (!sublist.length) return null;

    return (
      <div {...bemClassesAsideList('listContainer')}>
        <ul {...bemClassesAsideList('list')}>
          {!!currentForum &&
            <li
              {...bemClassesAsideList('item', 'link')}
              children={checkTitle(currentForum, bemClassesAsideList)}
            />
          }
          {map(sublist, (item, sublistKey)=> (
            <li
              key={sublistKey}
              {...bemClassesAsideList('item')}
              children={checkTitle(item, bemClassesAsideList)}
            />
          ))}
        </ul>
      </div>
    );
  }

  renderList =()=> {
    const { data, forumId, forumParent, topicTree } = this.props;
    const { device, sublistParent } = this.state;
    const isDesktop = device === 'desktop';

    if (!isDesktop) return null;
    /*
    if (!isDesktop) {
      let dropDownContent = sublistParent ?
        this.renderSublist() :
        (
          <ul {...bemClassesAsideList('list')}>
            {map(data, (item, key)=> {
              const active = forumId === item.id || forumParent === item.id;

              return (
                <li key={key} {...bemClassesAsideList('item')}>
                  <div
                    {...bemClassesAsideList('link', { active }, 'link')}
                    onClick={() => this.showSublist(item)}
                    title={item.forum_title}
                  >
                    <span {...bemClassesAsideList('linkContent')}>
                      <span {...bemClassesAsideList('text')} children={item.forum_title} />
                    </span>
                  </div>
                </li>
              )
            })}
          </ul>
        );

      const backBtn = sublistParent ? (
        <Button
          {...bemClassesAsideList('btn', 'back')}
          onClick={this.hideSublist}
          iconType={iconTypes.arrowSliderLeft}
          label="Назад"
        />
      ) : false;

      return (
        <DropDown
          {...bemClassesAsideList('dropdown')}
          ref={ref => this.ddRef = ref}
          onClose={this.hideSublist}
          modalHeaderProps={{
            className: bemClassesAsideList('headerModal').className,
            backButton: backBtn
          }}
        >
          <Button
            {...bemClassesAsideList('btn', 'dropdown')}
            iconSecondType={iconTypes.carretBild}
            label={forum_title}
          />
          {dropDownContent}
        </DropDown>
      )
    }
    */
    return (
      <ul
        {...bemClassesAsideList()}
        onMouseLeave={this.hideSublist}
      >
        {map(data, (item, key)=> {
          let active = forumId === item.id || forumParent === item.id;
          if (topicTree) {
            const topicTreeArr = topicTree.split('.');
            const index = indexOf(topicTreeArr, `${item.id}`);
            if (index > -1) active = true;
          }
          const hovered = sublistParent === item.id;

          if (item.forum_type !== 'link' && !item.children.length) return null;

          return (
            <li
              key={key}
              {...bemClassesAsideList('item', { hovered })}
              id={item.id}
              onClick={this.showSublist}
            >
              {checkButton(item, bemClassesAsideList, { active })}
              {hovered && isDesktop && this.renderSublist()}
            </li>
          );
        })}
      </ul>
    );
  }

  renderRootLinks =()=> {
    const { data } = this.props;
    // const { device } = this.state;
    // const isDesktop = device === 'desktop';

    // if (!isDesktop) return null;

    return (
      <ul {...bemClassesAsideList()}>
        {map(data, (item, key)=> (
          <li
            key={key}
            {...bemClassesAsideList('item', 'link')}
            children={checkTitle(item, bemClassesAsideList)}
          />
        ))}
      </ul>
    );
  }

  render() {
    // return this.renderList();
    // const { device } = this.state;
    // const { router, searchPlaceholder } = this.props;
    // const isDesktop = device === 'desktop';

    return (
      <>
        {/*
        {isDesktop &&
          <SearchInput
            {...bemClasses('search', 'aside')}
            router={router}
            linkBuilder={linksForum.sectionSearch}
            queryParamName="search"
            placeholder={searchPlaceholder}
          />
        }
        */}
        {this.renderRootLinks()}
      </>
    );
  }
}

export function getRandRootIds (topicList) {
  this.randRootIds = [];
  const filteredTopicList = filter(topicList, it => it.count > 0);
  const arr = Object.values(filteredTopicList);

  if (!arr || arr.length < 2) return this.randRootIds;

  const firstId = Math.floor(Math.random() * arr.length);
  this.randRootIds.push(arr[firstId]);

  let secondId = null;
  while (!secondId) {
    const id = Math.floor(Math.random() * arr.length);
    if (id !== firstId) secondId = id;
  }

  this.randRootIds.push(arr[secondId]);

  let thirdId = null;
  while (!thirdId) {
    const id = Math.floor(Math.random() * arr.length);
    if (id !== firstId && id !== secondId) thirdId = id;
  }

  this.randRootIds.push(arr[thirdId]);
  return this.randRootIds;
}
